import { Component, Input, OnInit, NgZone } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader } from '@agm/core';

declare var google: any;

@Component({
  selector: 'app-show-map-info',
  templateUrl: './show-map-info.component.html',
  styleUrls: ['./show-map-info.component.scss']
})
export class ShowMapInfoComponent implements OnInit {

  @Input() data;
  @Input() beacon;
  @Input() accuracy;
  public latitude: number;
  public longitude: number;
  public address: string;
  // Style mapy Google zaleznie od motywu — w trybie ciemnym mapa nie swieci
  // jasnym bialym prostokatem na ciemnym modalu.
  public mapStyles: any[] = [];

  // Ciemny styl mapy Google (oparty na standardowym presecie "night mode").
  private readonly darkMapStyles: any[] = [
    { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
    { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#d59563' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#263c3f' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#38414e' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#212a37' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#9ca5b3' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#746855' }] },
    { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#1f2835' }] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#f3d19c' }] },
    { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#2f3948' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#17263c' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#515c6d' }] },
    { featureType: 'water', elementType: 'labels.text.stroke', stylers: [{ color: '#17263c' }] }
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.mapStyles = document.body.classList.contains('dark-mode') ? this.darkMapStyles : [];

    this.latitude = parseFloat(this.data.latitude);
    this.longitude = parseFloat(this.data.longitude);

    if (this.latitude !== null && this.longitude !== null) {
      this.mapsAPILoader.load().then(() => {

        const geocoder = new google.maps.Geocoder();

        geocoder.geocode({
          'location': {
            lat: this.latitude,
            lng: this.longitude
          }
        }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK && results[0]) {
            this.ngZone.run(() => {
              this.address = results[0].formatted_address;
            });
          }
        });

      }).catch(() => {});
    }
  }

  close() {
    this.activeModal.close();
  }
}
